// Uses the existing privacy-filtered SDK identity; stores no visitor identifiers.
const EXPERIMENT = 'homepage_saved_sites_v1';
const DAY = 86400000;

export function homepageCta(config, capture) {
    const start = Number(config?.start);
    const now = Date.now();
    if (!start || now < start || now >= start + 28 * DAY
        || window.location.pathname !== '/' || window.location.search
        || navigator.doNotTrack === '1' || !window.posthog
        || typeof window.posthog.has_opted_out_capturing !== 'function'
        || window.posthog.has_opted_out_capturing()) return;
    const links = [...document.querySelectorAll('[data-homepage-registration-cta]')];
    if (!links.length || !window.IntersectionObserver) return;

    let assignment;
    try {
        const key = `${EXPERIMENT}:${start}`;
        const stored = window.localStorage.getItem(key);
        if (stored) {
            assignment = JSON.parse(stored);
            if (!['control', 'saved_sites'].includes(assignment.variant)) return;
        } else {
            // Classify only the referring host, never send or persist the URL.
            let host = '';
            try { host = new URL(document.referrer).hostname; } catch (error) { /* Direct/unknown. */ }
            if (!/^(www\.)?(google\.[a-z.]+|bing\.com|duckduckgo\.com|search\.yahoo\.com|search\.brave\.com)$/.test(host)) return;
            const random = new Uint32Array(1);
            window.crypto.getRandomValues(random);
            assignment = {variant: random[0] < 2147483648 ? 'control' : 'saved_sites'};
            window.localStorage.setItem(key, JSON.stringify(assignment));
            if (window.localStorage.getItem(key) !== JSON.stringify(assignment)) return;
        }
    } catch (error) {
        // Without durable assignment leave the existing copy untouched.
        return;
    }
    links.forEach((link) => {
        if (assignment.variant === 'saved_sites') link.textContent = link.dataset.homepageRegistrationCta;
    });
    let exposed = false;
    const observer = new window.IntersectionObserver((entries) => {
        if (exposed || document.visibilityState !== 'visible'
            || !entries.some((entry) => entry.isIntersecting && entry.intersectionRatio >= 0.5)) return;
        if (window.posthog.has_opted_out_capturing()) return;
        exposed = capture('homepage_registration_cta_exposure', {
            experiment: EXPERIMENT,
            variant: assignment.variant,
            experiment_start: start,
            acquisition_channel: 'organic',
        });
        if (exposed) observer.disconnect();
    }, {threshold: [0.5]});
    links.forEach((link) => observer.observe(link));
}
